'use client'

import { useRouter } from 'next/navigation'
import { FC, PropsWithChildren, useEffect, Fragment } from 'react'
import { useMaintenanceMode } from '../_hooks/useMaintenanceMode'

export const MaintenanceRedirect: FC<PropsWithChildren> = ({ children }) => {
  const router = useRouter()
  const { is_maintenance } = useMaintenanceMode()

  useEffect(() => {
    if (is_maintenance === true && window.location.pathname !== '/maintenance') {
      router.push('/maintenance')
    }
  }, [is_maintenance, router])

  return <Fragment>{children}</Fragment>
}
